import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useBooking } from "./BookingContext";

export default function StickyMobileCTA() {
  const { openBooking, open } = useBooking();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && !open && (
        <motion.div
          className="fixed inset-x-0 bottom-0 z-40 p-4 md:hidden"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        >
          <button
            data-testid="sticky-mobile-cta"
            onClick={openBooking}
            className="w-full bg-forest px-8 py-4 text-[0.78rem] uppercase tracking-[0.2em] text-warm shadow-[0_-8px_30px_rgba(0,0,0,0.25)]"
          >
            Book Strategy Call
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
